import React from 'react';

const TOOLS = [
  {
    number: '08',
    title: 'SlateVault — AI Media Asset Manager',
    description: 'Auto-index your local footage into a searchable cloud gallery. Proxies generated automatically. Every clip tagged by Gemini AI. $49/month.',
    href: '/#/slatevault',
    tag: 'MAM',
    featured: true,
  },
  {
    number: '01',
    title: 'Film Tax ROI Calculator',
    description: 'Estimate your after-tax cost of investing in a production slate. Calculate IRC §181 deductions and Pennsylvania production credits.',
    href: '/#/film-tax-calculator',
    tag: 'FINANCE',
  },
  {
    number: '02',
    title: 'Production Budget Estimator',
    description: 'Enter genre, shoot days, and cast size to get a department-by-department budget breakdown for your production.',
    href: '/#/budget-estimator',
    tag: 'PRODUCTION',
  },
  {
    number: '03',
    title: 'Distribution Revenue Modeler',
    description: 'Project your filmmaker net across VOD, theatrical, retail, and international channels based on your budget.',
    href: '/#/revenue-modeler',
    tag: 'DISTRIBUTION',
  },
  {
    number: '04',
    title: 'Investor Deck ROI Summary',
    description: 'Generate a professional, print-ready one-pager of your film investment — tax benefits, projected returns, and net effective cost.',
    href: '/#/investor-deck',
    tag: 'FINANCE',
  },
  {
    number: '05',
    title: 'Shoot Day Calculator',
    description: 'Convert your script into a production schedule. Get principal photography days, full timeline, and daily burn rate ranges.',
    href: '/#/shoot-calculator',
    tag: 'PRODUCTION',
  },
  {
    number: '06',
    title: 'SAG-AFTRA Tier Finder',
    description: 'Enter your budget and instantly see which SAG-AFTRA agreement applies — minimum rates and key provisions in plain English.',
    href: '/#/sag-finder',
    tag: 'LABOR',
  },
  {
    number: '07',
    title: 'Festival Submission Tracker',
    description: 'Track your film across 16 major festivals. Log status, fees, and results in one place — saved locally to your browser.',
    href: '/#/festival-tracker',
    tag: 'DISTRIBUTION',
  },
];

const TAG_COLORS = {
  FINANCE: 'text-sky-400 border-sky-800',
  PRODUCTION: 'text-emerald-400 border-emerald-800',
  DISTRIBUTION: 'text-violet-400 border-violet-800',
  LABOR: 'text-amber-400 border-amber-800',
  MAM: 'text-white border-zinc-500',
};

export default function ToolsHub() {
  return (
    <div className="min-h-screen bg-[#050505] text-white" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div className="border-b border-zinc-900 px-6 py-4 flex items-center justify-between">
        <a href="/#/" style={{ textDecoration: 'none' }} className="flex items-center gap-3">
          <img src="/logo.png" alt="Aperture Slate" className="h-8" />
          <span className="text-sm font-black tracking-widest text-white">APERTURE SLATE</span>
        </a>
        <a href="/#/" style={{ textDecoration: 'none' }} className="text-[11px] tracking-[0.15em] text-zinc-700 hover:text-zinc-400 uppercase transition-colors">
          Main Site
        </a>
      </div>

      <div className="px-6 pt-16 pb-24 max-w-4xl mx-auto">
        <p className="text-[11px] tracking-[0.4em] text-sky-400 font-bold uppercase mb-4">
          Aperture Slate // Professional Resources
        </p>
        <h1 className="text-5xl font-black tracking-tight uppercase leading-none">Filmmaker</h1>
        <h1 className="text-5xl font-black tracking-tight uppercase leading-none text-zinc-600 mb-6">Tools</h1>
        <p className="text-zinc-500 text-sm leading-relaxed max-w-xl mb-16">
          Free professional tools to help you plan, budget, and maximize your independent production. Built by filmmakers, for filmmakers.
        </p>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {TOOLS.map((tool) => (
            <a
              key={tool.number}
              href={tool.href}
              style={{ textDecoration: 'none' }}
              className="group border border-zinc-800 bg-zinc-950 p-6 hover:border-zinc-600 transition-all duration-200 block"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="text-[11px] font-black text-zinc-700 tracking-widest">{tool.number}</span>
                <span className={`text-[10px] font-bold tracking-widest border px-2 py-0.5 ${TAG_COLORS[tool.tag]}`}>
                  {tool.tag}
                </span>
              </div>
              <h3 className="text-base font-black tracking-wide uppercase text-white mb-3 group-hover:text-sky-400 transition-colors">
                {tool.title}
              </h3>
              <p className="text-zinc-500 text-xs leading-relaxed">{tool.description}</p>
              <div className="mt-5 text-[11px] tracking-widest text-zinc-600 group-hover:text-sky-500 transition-colors font-bold uppercase">
                Open Tool →
              </div>
            </a>
          ))}
        </div>

      </div>
    </div>
  );
}
